// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__rRMBG","resultNumber":"styles_resultNumber__923xN","searchedString":"styles_searchedString__IWsrH"};